// Hooks / Node modules / Styles
import { useState } from "react";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons

function ResearchCard({ research }) {
  const [isExpanded, setIsExpanded] = useState(false);

  // Join abstract paragraphs into a single text block
  const abstractText = research.abstract.join("\n\n");
  const shortAbstract =
    abstractText.slice(0, 208) + (abstractText.length > 1000 ? "..." : "");

  return (
    <div className="local-theme-bg-md local-theme-border-md shadow-lg rounded-lg p-6 border border-gray-200 relative">
      {/* Status Badge */}
      <span
        className={`absolute top-3 right-3 text-xs px-3 py-1 rounded-full font-semibold 
          ${
            research.status === "Published"
              ? "bg-green-100 text-green-800"
              : "bg-yellow-100 text-yellow-800"
          }`}
      >
        {research.status}
      </span>

      {/* Research Title */}
      <h2 className="text-xl font-semibold local-theme-text-md">{research.title}</h2>

      {/* Authors & Affiliation */}
      <p className="local-theme-text-sm text-sm">{research.authors}</p>
      <p className="local-theme-text-xs text-xs mt-2">{research.affiliation}</p>

      {/* Abstract */}
      <p className="whitespace-pre-line local-theme-text-sm mt-4 text-justify">
        {isExpanded ? abstractText : shortAbstract}
      </p>

      {/* Read Full / Collapse Button */}
      {abstractText.length > 1000 && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-blue-600 hover:underline mt-3 text-sm"
        >
          {isExpanded ? "Collapse" : "Read Full"}
        </button>
      )}
    </div>
  );
}

export default ResearchCard;
